<template>
    <div>
        <div v-if="availableMovieShows.length > 0 && !conflictScreens.length">
            <div class="row">
                <div class="col-5">
                    <div class="d-flex align-items-center">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <Datepicker :monday-first="true" ref="programaticOpen" v-model="startDate"
                                    name="duplicate_day_start_day" id="duplicate_day_start_day"
                                    :disabled-dates="disabledDates" v-validate="'required'" :typeable="true" />
                                <label class="active">Start Date</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="d-flex align-items-center">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <Datepicker :monday-first="true" ref="programaticOpen" v-model="endDate"
                                    name="duplicate_day_end_day" id="duplicate_day_end_day"
                                    :disabled-dates="disabledDates" v-validate="'required'" :typeable="true" />
                                <label class="active">End Date</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <table class="border my-3 duplicate-day-table w-100" style="table-layout: fixed" border="1">
                    <thead>
                        <tr>
                            <th>{{ "Movie" }}</th>
                            <th class="w-11p">{{ "Screen" }}</th>
                            <th class="w-11p">{{ "Start" }}</th>
                            <th class="w-11p">{{ "End" }}</th>
                            <th>{{ "Rate Cards" }}</th>
                            <th class="w-11p" v-if="availableMovieShows.length > 1"></th>
                        </tr>
                    </thead>
                    <tbody class="selectDaysTable" v-for="(movie, movieInndex) in availableMovieShows"
                        :key="movieInndex">
                        <tr>
                            <td style="white-space: break-spaces">{{ movie.movie }}</td>
                            <td style="white-space: break-spaces">{{ movie.screen_name }}</td>
                            <td>{{ movie.ss_start_show_time }}</td>
                            <td>{{ movie.ss_end_show_time }}</td>
                            <td class="fs-12" style="white-space: normal">
                                <div :title="getRateCardName(rc)" v-for="(rc, rcIndex) in movie.scheduleShowPrice"
                                    :key="rcIndex">
                                    {{ getRateCardName(rc) }}
                                </div>
                            </td>
                            <td v-if="availableMovieShows.length > 1" class="fixedWidth-10">
                                <div class="d-flex w-100 justify-content-center">
                                    <button class="btn-transparent rotate-btn" v-if="movie.rateCardCollapse" @click="
                                        onEditRateCardScreenDuplicate(movie, movieInndex)
                                        ">
                                        <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
                                    </button>
                                    <button class="btn-transparent" v-else @click="
                                        onEditRateCardScreenDuplicate(movie, movieInndex)
                                        ">
                                        <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr class="bg-lightbg">
                            <td colspan="6" v-if="movie.rateCardCollapse">
                                <b-collapse :id="'moreDetails-' + movieInndex"
                                    class="cinema-overview-collapse list-view-table scrollTable"
                                    v-model="movie.rateCardCollapse">
                                    <table class="tableRc border mb-3 rateCardCollapse-table">
                                        <thead>
                                            <tr>
                                                <th>{{ "Days" }}</th>
                                                <th v-for="(screenType,
                                                    screenTypeIndex) in movie['screen_data']['screen_seat_types']"
                                                    :key="'screenType' + screenTypeIndex">
                                                    {{ "Rate Card" }} ({{
                                                        screenType.sst_seat_type
                                                    }})
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="selectDaysTable" v-if="selectedMovieForEditWeekWiseDay">
                                            <tr v-for="(weekdaysLoop,
                                                weekdaysKey) in selectedMovieForEditWeekWiseDay.weekDayArray"
                                                :key="weekdaysKey">
                                                <td>
                                                    <b-form-checkbox :id="'checkbox' + weekdaysKey"
                                                        v-model="weekdaysLoop.value" class="j-checkbox mx-3 mb-3"
                                                        @change="
                                                            onChangeWeekdays_ds(
                                                                $event,
                                                                weekdaysLoop.dayName,
                                                                movieInndex
                                                            )
                                                            ">
                                                        <div class="text-capitalize">
                                                            {{ weekdaysLoop.dayName }}
                                                        </div>
                                                    </b-form-checkbox>
                                                </td>
                                                <td v-for="(weekPrice,
                                                    weekPriceIndex) in weekdaysLoop.scheduling_price"
                                                    :key="weekPriceIndex"
                                                    v-if="weekdaysLoop.scheduling_price.length > 0">
                                                    <div>
                                                        <div class="dropdown-curve-container w-230">
                                                            <multiselect class="" :allow-empty="false"
                                                                v-model="weekPrice['selected_rate_card']" :title="weekPrice &&
                                                                    weekPrice.selected_rate_card
                                                                    ? weekPrice.selected_rate_card
                                                                        .rc_g_name
                                                                    : ''
                                                                    " placeholder="" :options="filteredRateCardList(
                                                                        movie['screen_data'],
                                                                        weekPrice,
                                                                        RatecardsList
                                                                    )
                                                                        " label="rc_g_name" track-by="rc_g_id" @select="
                                                                            onChangeRateCardForDuplicateScreen(
                                                                                $event,
                                                                                weekPrice,
                                                                                weekdaysLoop,
                                                                                weekPriceIndex
                                                                            )
                                                                            " :multiple="false"></multiselect>
                                                            <label :class="weekPrice.selected_rate_card
                                                                ? 'shift-up'
                                                                : ''
                                                                ">
                                                                {{ "Rate Card" }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-collapse>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-md-12 text-center mt-4">
                    <button class="btn-blue" :disabled="availableMovieShows.length == 0"
                        :class="availableMovieShows.length == 0 ? 'disabled' : ''" @click="validateDuplicateSchdeule()">
                        {{ $t("Continue") }}
                    </button>
                </div>
            </div>
        </div>

        <div v-else-if="conflictScreens.length > 0">
            <div class="d-flex align-items-center">
                <button
                    :class="`btn-sm mx-2 ${selectedResolveScreen && selectedResolveScreen['screen_id'] == screen.screen_id ? 'bg-screen-btn-selected' : 'bg-screen-btn'}`"
                    v-for="(screen, screenIndex) in conflictScreens" :key="`Screen_${screenIndex}`"
                    @click="handleConflictScreenSelection(screen)">{{
                        screen.screen_name }}</button>
            </div>
            <div class="table-wrapper">
                <p class="text-left text-danger my-2"><span class="font-weight-bold">Conflitcs:</span> Overlapped with
                    {{
                        selectedScreenOverlappedShows.length }} movies</p>
                <div class="swc-report mb-4">
                    <table class="text-left conflictTable border mb-3 p-0 listviewtable" style="table-layout: fixed"
                        border="1">
                        <tr class="font-weight-bold">
                            <th>Date</th>
                            <th>Movie</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th colspan="2">Overlapping Movie/Event</th>
                            <th>Show Time</th>
                            <th>Occupancy</th>
                            <th>Replace</th>
                            <th>Ignore</th>
                        </tr>
                        <tbody class="sph-report" v-if="selectedScreenOverlappedShows.length">
                            <tr v-for="(overlap, overlapIndex) in selectedScreenOverlappedShows"
                                :key="`Overlap_${overlapIndex}`">
                                <td class="text-left">
                                    {{ overlap.ss_start_date }} <br /><span class="fs-12">{{
                                        moment(overlap.ss_start_date).format("dddd")
                                    }}</span>
                                </td>
                                <td v-b-popover.hover.bottom="{
                                    content: `${overlap.movie}`,
                                    html: true,
                                }">
                                    {{ overlap.movie }}
                                </td>
                                <td style="overflow: visible">
                                    <div class="custom-timepicker" v-if="overlap.isEdit">
                                        <vue-timepicker drop-direction="auto" v-model="overlap.ss_start_show_time"
                                            id="showtimeoverlap" name="showtimeoverlap" format="HH:mm"
                                            class="time_picker" input-width="100%" auto-scroll no-caret lazy
                                            :drop-offset-height="100" :manual-input="true" :hide-dropdown="true"
                                            :hide-clear-button="true" @change="
                                                editOverlappedTime(
                                                    overlap,
                                                    overlapIndex
                                                )
                                                "></vue-timepicker>
                                    </div>
                                    <div v-else>
                                        <span v-if="checkOverlapEdit(overlap)" @click="editTimeOverlap(overlap)"
                                            class="edit-pen blue-icon btn p-0"></span><span v-else class="mr-3"></span>
                                        {{ overlap.ss_start_show_time }}
                                    </div>
                                </td>
                                <td>{{ overlap.ss_end_show_time }}</td>
                                <td colspan="4" class="p-0">
                                    <table class="w-100 p-0" style="
                          table-layout: fixed;
                          border-top: none;
                          border-bottom: none;
                        ">
                                        <tr v-for="(overlapMovies,
                                            overlapMoviesIndex) in overlap.overlap_schedule" :key="overlapMoviesIndex"
                                            class="h-45">
                                            <td colspan="2" class="cell" :style="'background-color:' +
                                                overlapMovies.backgroundColor
                                                " v-b-popover.hover.bottom="{
                                                    title: `<div class='fs-14'> ${overlapMovies.movie}</div>`,
                                                    customClass: 'my-popover-class',
                                                    content: `
                          <div class='row fs-13'>
                          <div class='col-4 mr-0 pr-0'><b>Show Time:</b></div>
                          <div class='col-8 ml-0 pl-0'>${overlapMovies.ss_start_show_time
                                                        }-${overlapMovies.ss_end_show_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                                                            overlapMovies.ss_actual_start_date
                                                        ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy:</b></div>
                          <div class='col-8 ml-0 pl-0'>${overlapMovies.booked_seats
                                                        } Booked/ ${overlapMovies.unpaid_count} Unpaid/ ${overlapMovies.screen_total_seats
                                                        } Seats</div>
                          </div>
                          `,
                                                    html: true,
                                                }">
                                                {{ overlapMovies.movie }}
                                            </td>
                                            <td class="cell">
                                                {{ overlapMovies.ss_start_show_time }}-{{
                                                    overlapMovies.ss_end_show_time
                                                }}
                                            </td>
                                            <!-- <td class="cell">{{overlapMovies.ss_end_show_time}}</td> -->
                                            <td class="cell" :title="`(${overlapMovies.booked_seats}/${overlapMovies.unpaid_count}/${overlapMovies.screen_total_seats})`
                                                ">
                                                ({{ overlapMovies.booked_seats }} /
                                                {{ overlapMovies.unpaid_count }} /
                                                {{ overlapMovies.screen_total_seats }} seats)
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="text-center">
                                    <button v-if="checkOverlapEdit(overlap)" class="btn btn-sm btn-primary text-center"
                                        @click="onHandleReplaceOverlap(overlap, overlapIndex)">
                                        Replace</button><span :title="'Not Allowed'" v-else>Not Allowed</span>
                                </td>
                                <td class="text-center">
                                    <button class="btn btn-sm btn-primary"
                                        @click="onIgnoreOverlap(overlap, overlapIndex)">
                                        Ignore
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="10" class="text-center">No conflicts</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="text-left font-weight-bold text-success my-2">Resolved</p>
                <div class="swc-report mb-5">
                    <table class="text-left conflictTable border mb-3 p-0 listviewtable" border="1">
                        <thead>
                            <tr>
                                <th class="w-60">S.No</th>
                                <th>Date</th>
                                <th>Movie</th>
                                <th>Start Time</th>
                                <th>End Time</th>
                                <th>Remarks</th>
                                <th colspan="2">Overlapped Movie</th>
                                <th>Time</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="sph-report" v-if="selectedScreenResolvedShows.length">
                            <tr v-for="(resolved,
                                resolvedIndex) in selectedScreenResolvedShows" :key="resolvedIndex">
                                <td>{{ resolvedIndex + 1 }}</td>
                                <td class="noPadding">
                                    {{ resolved.ss_start_date }} <br /><span class="fs-12">{{
                                        moment(resolved.ss_start_date).format("dddd")
                                        }}</span>
                                </td>
                                <td>{{ resolved.movie }}</td>
                                <td>{{ resolved.ss_start_show_time }}</td>
                                <td>{{ resolved.ss_end_show_time }}</td>
                                <td>{{ resolved.remark || "-" }}</td>
                                <td colspan="3" class="p-0">
                                    <table v-if="resolved.overlap_schedule" style="table-layout: fixed"
                                        class="w-100 p-0 border h-45" border="1">
                                        <tr v-for="(resolvedMovies,
                                            resolvedMoviesIndex) in resolved.overlap_schedule"
                                            :key="resolvedMoviesIndex" class="p-0">
                                            <td colspan="2" v-b-popover.hover.bottom="{
                                                title: `<div class='fs-14'> ${resolvedMovies.movie}</div>`,
                                                customClass: 'my-popover-class',
                                                content: `
                          <div class='row fs-13'>
                          <div class='col-4 mr-0 pr-0'><b>Show Time:</b></div>
                          <div class='col-8 ml-0 pl-0'>${resolvedMovies.ss_start_show_time
                                                    }-${resolvedMovies.ss_end_show_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                                                        resolvedMovies.ss_actual_start_date
                                                    ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy:</b></div>
                          <div class='col-8 ml-0 pl-0'>${resolvedMovies.booked_seats
                                                    } Booked/ ${resolvedMovies.unpaid_count} Unpaid/ ${resolvedMovies.screen_total_seats
                                                    } Seats</div>
                          </div>
                          `,
                                                html: true,
                                            }">
                                                {{ resolvedMovies.movie }}
                                            </td>
                                            <td>
                                                {{ resolvedMovies.ss_start_show_time }}-{{
                                                    resolvedMovies.ss_end_show_time
                                                }}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="text-center">
                                    <button v-if="resolved.hasOwnProperty('overlap')" class="btn btn-sm btn-primary"
                                        @click="undoConflictResolve(resolved, resolvedIndex)">
                                        Undo
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="10" class="text-center">0 conflicts resolved</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <button :class="`btn-blue`" @click="saveResolvedSchedules" v-if="!overlapShows.length">Save</button>
                <button :class="`btn-blue`" @click="handleNextScreen" v-else>Next</button>
            </div>
        </div>
    </div>

</template>
<script>
import moment from "moment"
import DatePicker from "vue2-datepicker";
import _ from "lodash"
import scheduleService from "@/services/scheduleService";
import VueTimepicker from "vue2-timepicker";


export default {
    components: {
        DatePicker,
        VueTimepicker
    },
    props: {
        moviesList: [],
        weekDaysArray: [],
        RatecardsList: [],
        selectedMovieForEditWeekWiseDay: {},
        CinemasSettings: [],
        validScreens: [],
        timeZone: null,
        cinemaId: null,
        currentSelectedDay: null,
        handleDuplicateDayUpdation: () => { }
    },
    data() {
        return {
            startDate: moment().add(1, "day").format("YYYY-MM-DD"),
            endDate: moment().add(1, "day").format("YYYY-MM-DD"),
            weekDaysData: this.weekDaysArray,
            availableMovieShows: _.cloneDeep(this.moviesList),
            overlapShows: [],
            resolveShows: [],
            conflictScreens: [],
            // selectedScreenOverlappedShows: [],
            // selectedScreenResolvedShows: [],
            selectedResolveScreen: null,
            availableScreens: this.validScreens.reduce((acc, screen) => {
                if (!acc[screen.screen_id]) {
                    acc[screen.screen_id] = { ...screen }
                }
                return acc
            }, {}),
            conflictCount: 0
        }
    },
    computed: {
        selectedScreenOverlappedShows() {
            if (!this.selectedResolveScreen && !this.selectedResolveScreen['screen_id']) return []
            return this.overlapShows.filter(show =>
                show.screen_id === this.selectedResolveScreen.screen_id
            )
        },

        selectedScreenResolvedShows() {
            if (!this.selectedResolveScreen && !this.selectedResolveScreen['screen_id']) return []
            return this.resolveShows.filter(show =>
                show.screen_id === this.selectedResolveScreen.screen_id
            )
        }
    },
    methods: {
        moment,
        generateShowUid(show) {
            const base = `${show.screen_id}_${show.ss_start_date}`
            const suffix = Math.random().toString(36).slice(2, 8)
            return `${base}_${suffix}`
        },
        getRateCardName(rc) {
            let text = ``;
            text =
                rc.sst_seat_type +
                "-" +
                rc.rc_name +
                "-" +
                this.currFormat(rc.rc_total_amount);
            return text;
        },
        onEditRateCardScreenDuplicate(movie, movieIndex) {
            this.selectedMovieForEditWeekWiseDay = movie;
            this.availableMovieShows.forEach((movieShow, movieShowIndex) => {
                if (movieShowIndex == movieIndex) {
                    movieShow['rateCardCollapse'] = !movieShow['rateCardCollapse']
                } else {
                    movieShow.rateCardCollapse = false
                }
            })
            // this.availableMovieShows[movieIndex]['rateCardCollapse'] = !this.availableMovieShows[movieIndex]['rateCardCollapse']
            this.$forceUpdate();

            // this.duplicateScreenObj.moviesArray.forEach((x, index) => {
            //     if (movieIndex != index) {
            //         x.rateCardCollapse = false;
            //     }
            // });
            // this.duplicateScreenObj.moviesArray[movieIndex].rateCardCollapse = !this
            //     .duplicateScreenObj.moviesArray[movieIndex].rateCardCollapse;
            // //  this.$refs.rateCardWeekDayArray.show();
            // this.$forceUpdate();
        },
        onChangeWeekdays_ds(event, dayName, movieIndex) {
            console.log({ event, dayName, movieIndex })
            if (dayName !== "selectAll") {
                this.availableMovieShows[movieIndex].weekDayArray.forEach((x) => {
                    if (x.dayName == "selectAll") {
                        x["value"] = false;
                    }
                });
            } else if (dayName == "selectAll") {
                this.availableMovieShows[movieIndex].weekDayArray.forEach((x) => {
                    if (x.dayName !== "selectAll") {
                        x["value"] = event;
                    }
                });
            }

        },
        filteredRateCardList(screen, screenType, tempArr = []) {
            // console.log('selectedMovie filteredRateCardList', this.movieSelected, tempArr);
            let selectedScreen = _.cloneDeep(screen);
            let sst_id = screenType["sst_id"] || screenType["screen_seat_type_id"];
            let returnArray = [];
            let mappedRcArray = selectedScreen["selectedMappedRateCards"].filter(
                (x) => x.sst_id == sst_id
            );

            let isForeignMovie = "N";
            //   if (this.movieSelected && this.movieSelected.hasOwnProperty("is_foreign_movie") && this.movieSelected['is_foreign_movie'] && !this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)) {
            //     isForeignMovie = this.movieSelected['is_foreign_movie'] || "N"
            //   }

            if (
                selectedScreen["selectedMappedRateCards"].length == 0 ||
                mappedRcArray.length == 0 ||
                !sst_id
            ) {
                returnArray = _.cloneDeep(tempArr);
            } else {
                returnArray = tempArr.filter((x) =>
                    mappedRcArray.some((y) => y.rc_g_id == x.rc_g_id)
                );
            }
            return returnArray.filter((x) => x.is_foreign_rc == isForeignMovie);
        },
        onChangeRateCardForDuplicateScreen(rateCard, weekPrice, weekdaysLoop, weekPriceIndex) {
            let obj = {
                rate_card_group_id: rateCard.rc_g_id || null,
                rate_card_id: rateCard.rc_id || null,
                rate_card_name: rateCard.rc_g_name || null,
                rc_g_name: rateCard.rc_g_name,
                rc_name: rateCard.rc_name,
                screen_seat_type_id: weekPrice.screen_seat_type_id,
                searchRateCard: "",
                selected_rate_card: {
                    rc_g_id: rateCard.rate_card_group_id || null,
                    rc_id: rateCard.rc_id || null,
                    rc_g_name: rateCard.rc_g_name || null,
                },
                sst_seat_type: weekPrice.sst_seat_type,
            };

            if (weekdaysLoop.dayName == "selectAll") {
                this.selectedMovieForEditWeekWiseDay.weekDayArray.forEach((y) => {
                    Object.keys(y.scheduling_price[weekPriceIndex]).map((z) => {
                        y.scheduling_price[weekPriceIndex][z] = obj[z] || null;
                    });
                });
            } else {
                Object.keys(weekPrice).map((z) => {
                    weekPrice[z] = obj[z] || null;
                });
            }

            this.$forceUpdate();
        },
        generateDuplicateScheduleData(movieShowsData) {
            const screenWiseMovies = {}
            movieShowsData.forEach(movieShow => {
                const currentScreen = movieShow["screen_data"]
                const updatedMovieShowObj = { ...movieShow, scheduling_price: movieShow["scheduleShowPrice"] }
                if (!screenWiseMovies[currentScreen.screen_id]) {
                    screenWiseMovies[currentScreen.screen_id] = {
                        moviesArray: [updatedMovieShowObj],
                        screen_id: currentScreen.screen_id,
                        screen_name: currentScreen.screen_name
                    }

                } else {
                    screenWiseMovies[currentScreen.screen_id]["moviesArray"].push(updatedMovieShowObj)
                }
            })

            return Object.values(screenWiseMovies)
        },
        validateDuplicateSchdeule: async function () {
            let loader = this.$loading.show();
            try {
                if (!this.startDate || !this.endDate) {
                    return this.$toasted.show("Start Date and End Date required to duplicate schedules")
                }

                if (moment(this.startDate).isAfter(moment(this.endDate))) {
                    return this.$toasted.show("From Date should be before End Date")
                }

                const payload = {
                    CinemasSettings: this.CinemasSettings,
                    timeZone: this.timeZone,
                    ACTION: "VALIDATE",
                    MultipleSchedule: this.generateDuplicateScheduleData(this.availableMovieShows) || [],
                    cinema_id: this.CinemasSettings.cine_id,
                    sch_start_date: moment(this.startDate).format("YYYY-MM-DD"),
                    sch_end_date: moment(this.endDate).format("YYYY-MM-DD"),
                };

                console.log({ payload })

                const response = await scheduleService.addMultipleSchedule(payload)
                const { data } = response

                if (!data.status) {
                    return this.$toasted.show(data["message"] || "Schedule copying failed")
                }

                const screenWiseScheduleInsert = data.Records["screenArrayInsert"]
                if (!screenWiseScheduleInsert || !screenWiseScheduleInsert.length) {
                    return this.$toasted.show("screen wise data is empty, copying failed")
                }


                let overlappingShow = []
                let resolvedShow = []
                screenWiseScheduleInsert.forEach(screenShows => {
                    screenShows.moviesArray.forEach(movieShow => {
                        movieShow["created_at"] = moment(movieShow["created_at"]).format("YYYY-MM-DD HH:mm:ss")
                        movieShow["_uid"] = this.generateShowUid(movieShow)
                        if (movieShow["checkExistSchedule"]) {
                            movieShow["isEdit"] = false
                            movieShow["overlap"] = true
                            movieShow["screen_name"] = screenShows.screen_name
                            overlappingShow.push({ ...movieShow })
                            this.conflictCount = this.conflictCount + 1
                        } else {
                            resolvedShow.push({ ...movieShow })
                        }
                    })
                })

                overlappingShow = _.orderBy(
                    overlappingShow,
                    ["screen_id", "ss_start_date", "ss_start_show_time"],
                    ["asc", "asc", "asc"]
                );

                if (overlappingShow.length) {
                    // this.overlapShows = Object.values(overlappingShow.reduce((acc, show) => {
                    //     if (!acc[show.screen_id]) {
                    //         acc[show.screen_id] = {
                    //             screen_id: show.screen_id,
                    //             screen_name: show.screen_name,
                    //             moviesArray: [{ ...show }]
                    //         }
                    //     } else {
                    //         acc[show.screen_id]['moviesArray'].push({ ...show })
                    //     }

                    //     return acc
                    // }, {})) || []

                    // console.log(this.overlapShows, "this.overlapShows")
                    this.overlapShows = overlappingShow
                    this.resolveShows = resolvedShow

                    this.conflictScreens = Object.values(overlappingShow.reduce((acc, show) => {
                        if (!acc[show.screen_id]) {
                            acc[show.screen_id] = {
                                screen_id: show.screen_id,
                                screen_name: this.availableScreens[show.screen_id].screen_name
                            }
                        }

                        return acc
                    }, {}))
                    if (this.conflictScreens.length) {
                        this.selectedResolveScreen = this.conflictScreens[0]
                        this.handleConflictScreenSelection(this.conflictScreens[0])
                    }
                    console.log({ conflictScreens: this.conflictScreens })
                } else {
                    this.insertDuplicateSchedule()
                }

            } catch (error) {
                console.log(error)
            } finally {
                loader.hide();
            }
        },
        insertDuplicateSchedule: async function () {
            let loader = this.$loading.show();
            try {
                const payload = {
                    CinemasSettings: this.CinemasSettings,
                    timeZone: this.timeZone,
                    ACTION: "INSERT",
                    MultipleSchedule: this.generateDuplicateScheduleData(this.availableMovieShows) || [],
                    cinema_id: this.CinemasSettings.cine_id,
                    sch_start_date: moment(this.startDate).format("YYYY-MM-DD"),
                    sch_end_date: moment(this.endDate).format("YYYY-MM-DD"),
                };

                console.log({ payload })

                const response = await scheduleService.addMultipleSchedule(payload)
                const { data } = response

                console.log({ data }, "after insertion")
            } catch (error) {
                console.log(error)
            } finally {
                loader.hide();
            }
        },
        checkOverlapEdit(overlap) {
            let count = 0;
            overlap.overlap_schedule.map((x) => {
                if (x.booked_seats > 0) {
                    count++;
                }

                if (x.unpaid_count > 0) {
                    count++;
                }
            });

            if (count > 0) {
                return false;
            } else {
                return true;
            }
        },
        onHandleReplaceOverlap(overlap, overlapIndex) {
            console.log({ overlap, overlapIndex })
            overlap["remark"] = `Replaced (${overlap.overlap_schedule.length})x`;
            overlap["is_replaced"] = true;
            const overlapMovieIndex = this.overlapShows.findIndex(show => show._uid == overlap._uid)
            this.overlapShows.splice(overlapMovieIndex, 1)
            this.resolveShows.push({ ...overlap, });
        },
        onIgnoreOverlap(overlap, overlapIndex) {
            console.log({ overlap, overlapIndex })
            overlap["remark"] = "Ignored";
            this.resolveShows.push({ ...overlap, });
            this.overlapShows = this.overlapShows.filter(overlapShow => {
                return overlapShow._uid != overlap._uid
            });
        },
        undoConflictResolve(resolved, resolveIndex) {
            console.log({ resolved, resolveIndex })
            resolved['remark'] = ""
            const overlapShowsData = _.cloneDeep([...this.overlapShows, { ...resolved }])


            this.overlapShows = _.orderBy(
                overlapShowsData.map((show, index) => ({
                    ...show,
                })),
                ["screen_id", "ss_start_date", "ss_start_show_time"],
                ["asc", "asc", "asc"]
            );
            this.resolveShows = this.resolveShows.filter(resolveShow => {
                return resolveShow._uid != resolved._uid
            })
        },
        handleConflictScreenSelection(screen) {
            this.selectedResolveScreen = screen
            // this.selectedScreenOverlappedShows = this.overlapShows.filter(shows => {
            //     return shows.screen_id == screen.screen_id && shows["remark"] != 'Ignored'
            // })
            // this.selectedScreenResolvedShows = this.resolveShows.filter(shows => {
            //     return shows.screen_id == screen.screen_id
            // })
            console.log({ selectedScreenOverlappedShows: this.selectedScreenOverlappedShows, selectedScreenResolvedShows: this.selectedScreenResolvedShows })
        },
        saveResolvedSchedules: async function () {
            let loader = this.$loading.show();
            try {
                console.log({ conflictCount: this.conflictCount, resolveShows: this.resolveShows.length })
                const confirmedSchedules = [...this.overlapShows, ...this.resolveShows]
                const confirmedSchedulePayload = {}
                confirmedSchedules.forEach(schedule => {
                    if (!confirmedSchedulePayload[schedule.screen_id]) {
                        confirmedSchedulePayload[schedule.screen_id] = {
                            screen_id: schedule.screen_id,
                            created_at: moment(schedule.created_at).format("YYYY-MM-DD HH:mm:ss"),
                            sch_end_date: moment(this.endDate).format("YYYY-MM-DD"),
                            sch_start_date: moment(this.startDate).format("YYYY-MM-DD"),
                            moviesArray: [{ ...schedule }],
                            sch_is_active: "Y"
                        }
                    } else {
                        confirmedSchedulePayload[schedule.screen_id]['moviesArray'].push({ ...schedule })
                    }
                })

                const payload = {
                    cinema_id: this.CinemasSettings.cine_id,
                    schedule_array: Object.values(confirmedSchedulePayload)
                }

                console.log({ payload })

                const response = await scheduleService.saveOverlapConflicts(payload)
                const { data } = response

                if (data.status) {
                    this.$emit("handleDuplicateDayUpdation")
                } else {
                    this.$toasted.show(data["message"] || "Nothing to save")
                }

            } catch (error) {
                console.log(error)
            } finally {
                loader.hide();
            }
        },
        editTimeOverlap(overlap) {
            console.log({ overlap })
            overlap["isEdit"] = !overlap["isEdit"];
            this.$forceUpdate();
        },
        editOverlappedTime: async function (overlap, overlapIndex) {
            let loader = this.$loading.show();
            try {
                const moviesArr = overlap.hasOwnProperty("overlap_with_movie_obj")
                    ? [overlap.overlap_with_movie_obj]
                    : [];
                moviesArr[0].ss_start_show_time = moment(
                    overlap.ss_start_show_time,
                    "HH:mm"
                ).format("HH:mm");
                moviesArr[0].start_time = moment(
                    overlap.ss_start_show_time,
                    "HH:mm"
                ).format("HH:mm");

                if (moviesArr.length == 0) {
                    return this.$toasted.show("Something Went Wrong!, No Movies Found");
                }

                const validateUpdatedTimePayload = {
                    CinemasSettings: this.CinemasSettings,
                    timeZone: this.timeZone,
                    ACTION: "VALIDATE",
                    MultipleSchedule: this.generateDuplicateScheduleData(moviesArr) || [],
                    cinema_id: this.CinemasSettings.cine_id,
                    sch_start_date: moment(this.startDate).format("YYYY-MM-DD"),
                    sch_end_date: moment(this.endDate).format("YYYY-MM-DD"),
                };
                console.log({ validateUpdatedTimePayload })

                const response = await scheduleService.addMultipleSchedule(validateUpdatedTimePayload)
                const { data } = response

                if (!data.status) {
                    return this.$toasted.show(data["message"] || "Schedule validation failed")
                }
                let count = 0;
                const scheduleData = []
                data.Records.screenArrayInsert.forEach(movieScreen => {
                    movieScreen.moviesArray.forEach(movie => {
                        if (movie.checkExistSchedule) {
                            count++;
                            scheduleData.push(movie);
                        } else {
                            scheduleData.push(movie);
                        }
                    })
                })
                const overlappingMovieIndex = this.overlapShows.findIndex(show => show._uid == overlap._uid)

                if (count > 0) {
                    this.$toasted.show(
                        `Overlapped with ${scheduleData[0].overlap_schedule[0].movie}`
                    );
                    scheduleData[0]["overlap"] = true
                    this.overlapShows[overlappingMovieIndex] = { ...scheduleData[0], isEdit: false, _uid: overlap._uid }
                    this.$forceUpdate();
                } else {
                    this.overlapShows.splice(overlappingMovieIndex, 1)
                    scheduleData[0]["_uid"] = overlap._uid;
                    scheduleData[0]["remark"] = "Time Changed";
                    scheduleData[0]["checkExistSchedule"] = false;
                    scheduleData[0]["overlap"] = true;
                    scheduleData[0]["overlap_schedule"] =
                        overlap.overlap_schedule;
                    this.resolveShows.push({ ...scheduleData[0] });
                    this.$toasted.show("Conflict Resolved")
                }
            } catch (error) {
                console.log(error)
            } finally {
                loader.hide();
            }
        },
        handleNextScreen() {
            if (!this.conflictScreens.length) {
                return this.$toasted.show("No conflict screens available")
            }
            if (this.selectedScreenOverlappedShows.length) {
                return this.$toasted.show("Please resolve all conflicts in this screen before proceeding")
            }
            const currentIndex = this.conflictScreens.findIndex(screen => screen.screen_id == this.selectedResolveScreen.screen_id)
            if (currentIndex + 1 < this.conflictScreens.length) {
                this.handleConflictScreenSelection(this.conflictScreens[currentIndex + 1])
            }
        }
    }
}
</script>
<style>
.duplicate-day-table {
    font-size: 12px;
}

.duplicate-day-table th,
.duplicate-day-table td {
    padding: 3px 8px
}

.bg-screen-btn {
    border: 1px solid #6ca1f1;
    color: #6ca1f1;
    background-color: #fff;
}

.bg-screen-btn-selected {
    background-color: #6ca1f1;
    border: 1px solid transparent;
    color: #fff
}


.conflictTable {
    table-layout: auto !important;
    white-space: nowrap;
    border-radius: 10px;
    margin-bottom: 50px;
    background-color: #fff;
}


.listviewtable th,
.listviewtable td {
    padding: 5px 10px 5px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleComponents/duplicateDay.vue